// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"90b6f698","359":"20bc29c4","411":"c57f0014","453":"8ae54db0","591":"b5c7b657","618":"cda53b49","764":"c3262d01","874":"0cf33817"}[chunkId] + ".chunk.js";
};